import { Module } from '@type/module.type';
import { UserRole } from '@type/user.type';

export class UserHelper {
  static getRolesMatrix(): Record<string, Module[]> {
    return {
      [UserRole.keymaster.toString()]: [Module.kms],
      [UserRole.admin.toString()]: [
        Module.admin,
        Module.operator,
        Module.kms,
      ],
      [UserRole.operator.toString()]: [
        Module.admin,
        Module.operator,
      ],
      [UserRole.porter.toString()]: [],
      [UserRole.van_driver.toString()]: [],
    };
  }


}
